import type { useContentLastUpdatedDetailsPanelContentLastUpdatedQuery as DetailsPanelContentLastUpdatedQuery } from '../hooks/__types__/useContentLastUpdatedDetailsPanelContentLastUpdatedQuery';
import { hasAccountId } from '../userUtils';

export const normalizeContentLastUpdatedData = (data?: DetailsPanelContentLastUpdatedQuery) => {
	const lastUpdatedBy = data?.content?.nodes?.[0]?.history?.lastUpdated?.by;

	return {
		accountId: hasAccountId(lastUpdatedBy) ? lastUpdatedBy?.accountId : '',
		displayName: lastUpdatedBy?.displayName ?? '',
		profilePicturePath: lastUpdatedBy?.profilePicture?.path,
	};
};
